import { render, staticRenderFns } from "./Oldhome.vue?vue&type=template&id=49d4c63e&scoped=true&"
import script from "./Oldhome.vue?vue&type=script&lang=js&"
export * from "./Oldhome.vue?vue&type=script&lang=js&"
import style0 from "./Oldhome.vue?vue&type=style&index=0&id=49d4c63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4c63e",
  null
  
)

export default component.exports